/**
 * Service Account API types.
 *
 * Mirrors the backend OpenAPI contracts under
 * `Infrastructure/OpenApi/ServiceAccount/*` from the DMS backend
 * (teas/backend-monorepo, MRs T20-122153 / T20-122156). Field names follow
 * the backend JSON exactly (camelCase): `privateKeyPem`, `publicKeyPem`,
 * `keyId`, `maxTokenLifetime`.
 */

export type ServiceAccountStatus = 'active' | 'inactive' | 'deleted';

export type ServiceAccountKeyStatus = 'active' | 'rotating' | 'expired';

export type CreateServiceAccountRequestBody = {
  name: string;
  description?: string | null;
  email: string;
  roles: string[];
  branches: string[];
  maxTokenLifetime: number;
};

export type CreateServiceAccountApiArg = {
  createServiceAccountRequestBody: CreateServiceAccountRequestBody;
};

export type CreateServiceAccountApiResponse = {
  id: string;
  keyId: string;
  privateKeyPem: string;
};

export type ServiceAccountResponseBody = {
  id: string;
  userId: string;
  name: string;
  description: string | null;
  maxTokenLifetime: number;
  status: ServiceAccountStatus;
  createdAt: string;
  createdBy: string;
};

export type GetServiceAccountApiArg = {
  serviceAccountId: string;
};

export type GetServiceAccountApiResponse = ServiceAccountResponseBody;

export type UpdateServiceAccountRequestBody = {
  name: string;
  description?: string | null;
  roles: string[];
  branches: string[];
};

export type UpdateServiceAccountApiArg = {
  serviceAccountId: string;
  updateServiceAccountRequestBody: UpdateServiceAccountRequestBody;
};

export type UpdateServiceAccountApiResponse = void;

export type ActivateServiceAccountApiArg = {
  serviceAccountId: string;
};

export type ActivateServiceAccountApiResponse = void;

export type DeactivateServiceAccountApiArg = {
  serviceAccountId: string;
};

export type DeactivateServiceAccountApiResponse = void;

export type DeleteServiceAccountApiArg = {
  serviceAccountId: string;
};

export type DeleteServiceAccountApiResponse = void;

export type ServiceAccountKeyResponseBody = {
  id: string;
  publicKeyPem: string;
  createdAt: string;
  status: ServiceAccountKeyStatus;
  rotatingUntil: string | null;
};

export type ListServiceAccountKeysApiArg = {
  serviceAccountId: string;
};

export type ListServiceAccountKeysApiResponse = {
  keys: ServiceAccountKeyResponseBody[];
};

export type RotateServiceAccountKeyApiArg = {
  serviceAccountId: string;
};

export type RotateServiceAccountKeyApiResponse = {
  keyId: string;
  privateKeyPem: string;
};

export type RevokeServiceAccountKeyApiArg = {
  serviceAccountId: string;
  keyId: string;
};

export type RevokeServiceAccountKeyApiResponse = void;
